import loadable from '@loadable/component';

export const LocationSwitcherModalContainerLoadable = loadable(() => import('./ModalContainer'), {
  resolveComponent: ({ LocationSwitcherModalContainer }) => LocationSwitcherModalContainer,
});
